import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import AppLayout from "../components/AppLayout";

const plans = [
  { price: "pro_monthly", name: "Pro", amount: "R$ 19,90", detail: "Para profissionais que estão começando." },
  { price: "pro_plus_monthly", name: "Pro+", amount: "R$ 39,90", detail: "Para uma rotina de acompanhamento mais intensa." },
];

export default function Plano() {
  const [access, setAccess] = useState(null);
  const [busy, setBusy] = useState("");
  const [error, setError] = useState("");
  const [params] = useSearchParams();
  async function refresh() {
    try {
      const response = await fetch("/api/billing/status", { credentials: "include", cache: "no-store" });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || "Não foi possível consultar seu plano.");
      setAccess(data);
    } catch (e) { setError(e.message); }
  }
  useEffect(() => { refresh(); }, []);
  async function start(price) {
    setBusy(price); setError("");
    try {
      const response = await fetch("/api/billing/checkout", { method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ price }) });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || "Não foi possível iniciar o pagamento.");
      window.location.assign(data.checkout_url);
    } catch (e) { setError(e.message); setBusy(""); }
  }
  async function manage() {
    setBusy("portal"); setError("");
    try {
      const response = await fetch("/api/billing/portal", { method: "POST", credentials: "include" });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || "Não foi possível abrir a gestão da assinatura.");
      window.location.assign(data.portal_url);
    } catch (e) { setError(e.message); setBusy(""); }
  }
  return <AppLayout><div className="titulo-com-acao"><div><p className="sobretitulo">Assinatura</p><h1>Seu plano DiárioMed</h1><p>Escolha ou gerencie seu plano profissional.</p></div></div>
    {params.get("checkout") === "success" && <aside className="notice"><strong>Pagamento em confirmação</strong><p>O Payments Hub atualizará seu acesso assim que confirmar a cobrança.</p><button className="botao secundario" onClick={refresh}>Atualizar status</button></aside>}
    {params.get("checkout") === "cancel" && <aside className="notice"><strong>Pagamento não concluído</strong><p>Você pode tentar novamente quando quiser.</p></aside>}
    {error && <p className="erro" role="alert">{error}</p>}
    {access?.active && <aside className="notice"><strong>Plano ativo: {access.plan || "Profissional"}</strong>{access.valid_until && <p>Válido até {new Date(access.valid_until).toLocaleDateString("pt-BR")}</p>}<button className="botao secundario" disabled={busy === "portal"} onClick={manage}>{busy === "portal" ? "Abrindo…" : "Gerenciar assinatura"}</button></aside>}
    <section className="grid-acompanhamentos">{plans.map(plan => <article className="acompanhamento" key={plan.price}><span className="badge">Mensal</span><h2>{plan.name}</h2><p><strong>{plan.amount}</strong> / mês</p><p>{plan.detail}</p><button className="botao primario" disabled={Boolean(busy)} onClick={() => start(plan.price)}>{busy === plan.price ? "Abrindo checkout…" : `Assinar ${plan.name}`}</button></article>)}</section>
  </AppLayout>;
}
